export default "__VITE_ASSET__D1TSr6BA__"